export default ({ request }) => ({
    sysInoutTemplateListApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplate/list',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateDetailApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplate/detail',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateSaveApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplate/save',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateDelApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplate/del',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateAttachmentListApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplateAttachment/list',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateAttachmentSaveApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplateAttachment/save',
            method: 'post',
            data,
        })
    },
    sysInoutTemplateAttachmentDelApi(data = {}) {
        return request({
            url: '/sys/sysInoutTemplateAttachment/del',
            method: 'post',
            data,
        })
    },
})
